/**
 * Where Help, Terms and Privacy are published: the Tech Sight business website, not this app.
 * (CEO, 12 Oct 2026: "They should be a subdirectory in the business website ... It should not be on Vercel".)
 */
export const HELP_URL = 'https://techsight.co.za/linguistpro/help/';
export const TERMS_URL = 'https://techsight.co.za/linguistpro/terms/';
export const PRIVACY_URL = 'https://techsight.co.za/linguistpro/privacy/';

/** Help URL, optionally with a section anchor (without the leading '#'). */
export function helpUrl(hash?: string): string {
  return hash ? `${HELP_URL}#${hash}` : HELP_URL;
}
